import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../Reusable/Spinner";

interface IAccessControlProps {
  allowedPermissions: any;
  children: any;
  renderNoAccess?: any;
}

const AccessControl = ({
  allowedPermissions,
  children,
  renderNoAccess,
}: IAccessControlProps) => {
  const { data, isLoading } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const permissionsLists: any =
    data && data?.groups?.map((item: any) => item.custom_permissions).flat();
  let isAllowed: boolean = permissionsLists?.some(
    (permission: any) =>
      allowedPermissions.includes(permission) ||
      allowedPermissions.includes("no-permission-required")
  );

  if (isLoading) {
    return;
  }

  if (isAllowed || data?.is_superuser) {
    return children;
  }

  return renderNoAccess ?? null;
};

export default AccessControl;
